import React, { useState ,useEffect } from "react"; 
import { Link } from "react-router-dom";
import Header from'../Component/Header'; 
import { form1 } from "../Service/Api";
import { getHeader } from "../config";
import Footer from '../Component/Footer';  
function ContactUs() { 
  useEffect(() => {
    document.title = 'Contact Us -  Mercy Memorial School, Kanpur';  
}, []); 
const [formData, setFormData] = useState({
  name: "", 
  phone: "",
  email: "",
  subject: "",
  message: "",
});
const [errors, setErrors] = useState({});

const handleChange = (e) => {
  setFormData({
      ...formData,
      [e.target.name]: e.target.value
  });
  setErrors({ ...errors, [e.target.name]: "" }); // Clear the error for the field being changed
};

const validateForm = () => {
  const newErrors = {};
  if (!formData.name) newErrors.name = "Name is required.";
  if (!formData.email) {
      newErrors.email = "Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is not valid.";
  }
  if (!formData.phone) newErrors.phone = "Phone Number is required.";
  if (!formData.subject) newErrors.subject = "Subject is required.";
  if (!formData.message) newErrors.message = "Message is required.";
  return newErrors;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validateForm();
  if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
  }

  const type = 'abc'; 
  console.log('Submitting form with type:', type); // Debugging line
  try {
      const { header } = getHeader();
      const response = await form1(formData, header, type); 
      
      document.querySelector(".primary-alert").innerHTML = "<p>Your Form Submitted Successfully.</p>";
      setFormData({
          name: "", 
          phone: "",
          email: "",
          subject: "",
          message: "",
      });
  } catch (error) {
      console.error('Error submitting form:', error);
  }
};
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Contact Us</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Contact Us</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                    
               <div className="enquiryform">
               <div className="enquiryformimg locationimg">
                  <h3 className="smallheadimg">Get In Touch With Us</h3>
                     <div className="locationbox">
                         <div className="locationdiv">
                              <div className="locationicon">
                                  <i className="bi bi-geo-alt"></i>
                              </div>
                              <div className="locationdetails">
                                  <h5>Location</h5>
                                  <p><a href="https://goo.gl/maps/NwkFsGt1BUR2wk968" target="_blank">1272 - 1427 - Y Block, Kidwai Nagar Kanpur Nagar, Uttar Pradesh - 208011</a></p>
                              </div>
                         </div>
                         <div className="locationdiv">
                              <div className="locationicon">
                                  <i className="bi bi-telephone"></i>
                              </div>
                              <div className="locationdetails">
                                  <h5>Phone</h5>
                                  <p><a href="tel:+91-512-4000406"> +91-512-4000406 </a>, <a href="tel:+91-512-4000407">4000407 </a></p>
                              </div>
                         </div>
                         <div className="locationdiv">
                              <div className="locationicon">
                                  <i className="bi bi-envelope"></i>
                              </div>
                              <div className="locationdetails">
                                  <h5>Email</h5>
                                  <p><a href="mailto:mercyknp83@gmail.com"> mercyknp83@gmail.com </a></p>
                              </div>
                         </div>
                     </div>
               </div>
               <div className="enquiryformsec">
                   <h3 className="smallheading">Send Us Message <span>If you have some feedback or want to ask any questions</span></h3>
                     <form onSubmit={handleSubmit}>
                          <div className="row">
                          <div className="col">
                            <input type="text" placeholder="Full Name" name="name" className="form-control" value={formData.name} onChange={handleChange}/>
                            {errors.name && <div className="error">{errors.name}</div>}
                          </div>
                          <div className="col">
                          <input type="text" placeholder="Mobile No." name="phone" className="form-control" value={formData.phone} onChange={handleChange}/>
                            {errors.phone && <div className="error">{errors.phone}</div>}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                          <input type="text" placeholder="Email" name="email" className="form-control" value={formData.email} onChange={handleChange}/>
                          {errors.email && <div className="error">{errors.email}</div>}
                          </div>
                          <div className="col">
                          <input type="text" placeholder="Subject" name="subject" className="form-control" value={formData.subject} onChange={handleChange}/>
                          {errors.subject && <div className="error">{errors.subject}</div>} 
                          </div>
                        </div>
                        <div className="row">
                            <div className="col">
                            <textarea name="message" className="form-control" value={formData.message} onChange={handleChange}></textarea>
                            {errors.message && <div className="error">{errors.message}</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col sendbtn">
                                  <input type="submit" value="Send Now"/>
                            </div>
                        </div>
                     </form>
                     <div className="primary-alert"></div>
               </div>
           </div>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ContactUs;
